module.exports = __webpack_public_path__ + "img/pro-top.84e20702.png";